<template>
    <NuxtLayout name="main" :dark="true" :favorite="true">
        <!-- * 确认窗口 -->
        <confirm-modal ref="confirm" :width="648" height="auto" @confirm="methods.confirm">{{ $t("PredictionMutationDELConfirm") }}</confirm-modal>
        <ui-modal ref="info" height="auto" spacing="32px 56px 40px">
            <div class="text-emphas text-[30px] leading-[46px] font-bold">{{ $t("ModelIntroduction") }}</div>
            <div class="mt-[16px]">
                <p>{{ $t("RNASplicerDescript2") }}</p>
                <p class="mt-[8px]">{{ $t("RNASplicerDescript3") }}</p>
                <p class="mt-[8px]">{{ $t("RNASplicerDescript4") }}</p>
            </div>
        </ui-modal>

        <!-- * 内容 -->
        <div :class="css.container">
            <section :class="css.main" class="container">
                <h1 :class="css.name">{{ $t("RNASplicer") }}</h1>
                <div :class="css.description" class="text-center">{{ $t("RNASplicerDescript") }}</div>
                <div :class="css.inputs">
                    <mutations-inputs ref="inputs" mode="RNA Splicer" v-on="ons.inputs" />
                </div>
            </section>

            <section :class="css.why" class="container">
                <h2 :class="css.name">{{ $t("RNASplicerFAQName1") }}</h2>
                <div :class="css.content">
                    <div :class="css.descriptions">
                        <div>{{ $t("RNASplicerFAQ1Answer1") }}</div>
                        <div>{{ $t("RNASplicerFAQ1Answer2") }}</div>
                        <div>{{ $t("RNASplicerFAQ1Answer3") }}</div>
                        <div>{{ $t("RNASplicerFAQ1Answer4") }}</div>
                        <div class="mt-[16px] text-[#384053] font-bold">{{ $t("RNASplicerFAQ1Answer5") }}</div>
                    </div>
                </div>
            </section>

            <section :class="css.lightspot" class="container">
                <h2 :class="css.name">{{ $t("RNASplicerFAQName2") }}</h2>
                <div :class="css.content">
                    <div :class="css.cards">
                        <div :class="css.item">
                            <h3 :class="css.title">{{ $t("RNASplicerlightspot1Title") }}</h3>
                            <div :class="css.text">{{ $t("RNASplicerlightspot1Text") }}</div>
                        </div>
                        <div :class="css.item">
                            <h3 :class="css.title">{{ $t("RNASplicerlightspot2Title") }}</h3>
                            <div :class="css.text">{{ $t("RNASplicerlightspot2Text") }}</div>
                        </div>
                        <div :class="css.item">
                            <h3 :class="css.title">{{ $t("RNASplicerlightspot3Title") }}</h3>
                            <div :class="css.text">{{ $t("RNASplicerlightspot3Text") }}</div>
                        </div>
                        <div :class="css.item">
                            <h3 :class="css.title">{{ $t("RNASplicerlightspot4Title") }}</h3>
                            <div :class="css.text">{{ $t("RNASplicerlightspot4Text") }}</div>
                        </div>
                        <div :class="css.item">
                            <h3 :class="css.title">{{ $t("RNASplicerlightspot5Title") }}</h3>
                            <div :class="css.text">{{ $t("RNASplicerlightspot5Text") }}</div>
                        </div>
                    </div>
                </div>
            </section>

            <section :class="css.explains" class="container">
                <h2 :class="css.name">{{ $t("RNASplicerDetailedOperatingSteps") }}</h2>
                <div :class="css.video">
                    <iframe
                        src="//player.bilibili.com/player.html?isOutside=true&aid=114412912383470&bvid=BV1m7LCz9EL6&cid=29640360222&p=1"
                        scrolling="no"
                        border="0"
                        frameborder="no"
                        framespacing="0"
                        allowfullscreen="true"
                        v-if="$i18n.locale == 'zh'" />

                    <iframe
                        src="https://www.youtube.com/embed/j74Nr-HlAFE?si=UDzHEiLMKXFa_wqY"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin"
                        allowfullscreen
                        v-else />
                </div>

                <div :class="css.stepses">
                    <div :class="css.steps">
                        <h3 :class="css.name">{{ $t("RNASplicerOperatingSteps1") }}</h3>
                        <div :class="css.image">
                            <img v-src="1" />
                        </div>
                    </div>

                    <div :class="css.steps">
                        <h3 :class="css.name">{{ $t("RNASplicerOperatingSteps2") }}</h3>
                        <div>
                            {{ $t("RNASplicerOperatingSteps2Description1") }}
                            <span class="font-bold" :class="css.example">{{ $t("RNASplicerOperatingSteps2Description1Example") }}</span>
                        </div>
                    </div>

                    <div :class="css.steps">
                        <h3 :class="css.name">{{ $t("RNASplicerOperatingSteps3") }}</h3>
                        <div>
                            <div>
                                <span class="font-bold" :class="css.example">{{ $t("RNASplicerOperatingSteps3Description1") }} </span
                                >{{ $t("RNASplicerOperatingSteps3Description1Example") }}
                            </div>
                            <div>
                                <span class="font-bold" :class="css.example">{{ $t("RNASplicerOperatingSteps3Description2") }} </span
                                >{{ $t("RNASplicerOperatingSteps3Description2Example") }}
                            </div>
                        </div>
                    </div>

                    <div :class="css.steps">
                        <h3 :class="css.name">{{ $t("RNASplicerOperatingSteps4") }}</h3>
                        <div>
                            <div>
                                <span class="font-bold" :class="css.example">{{ $t("RNASplicerOperatingSteps4Description1") }} </span
                                >{{ $t("RNASplicerOperatingSteps4Description1Example") }}
                            </div>
                            <div>
                                <span class="font-bold" :class="css.example">{{ $t("RNASplicerOperatingSteps4Description2") }} </span
                                >{{ $t("RNASplicerOperatingSteps4Description2Example") }}
                            </div>
                        </div>
                    </div>
                    <div :class="css.steps">
                        <div>
                            <div>{{ $t("RNASplicerOperatingSteps4Msg") }}</div>
                            <div>{{ $t("RNASplicerOperatingSteps4Msg2") }}</div>
                        </div>
                    </div>
                    <div :class="css.steps">
                        <h3 :class="css.name">{{ $t("RNASplicerOperatingSteps5") }}</h3>
                        <div>
                            <i18n-t keypath="RNASplicerOperatingSteps5Description1" tag="div">
                                <template #name>
                                    <span class="font-bold" :class="css.example">{{ $t("RNASplicerOperatingSteps5Description1Example") }}</span>
                                </template>
                            </i18n-t>
                            <i18n-t keypath="RNASplicerOperatingSteps5Description2" tag="div">
                                <template #name>
                                    <span class="font-bold" :class="css.example">{{ $t("RNASplicerOperatingSteps5Description2Example") }}</span>
                                </template>
                            </i18n-t>
                            <i18n-t keypath="RNASplicerOperatingSteps5Description3" tag="div">
                                <template #name>
                                    <span class="font-bold" :class="css.example">{{ $t("RNASplicerOperatingSteps5Description3Example") }}</span>
                                </template>
                            </i18n-t>
                            <i18n-t keypath="RNASplicerOperatingSteps5Description4" tag="div">
                                <template #name>
                                    <span class="font-bold" :class="css.example">{{ $t("RNASplicerOperatingSteps5Description4Example") }}</span>
                                </template>
                            </i18n-t>
                        </div>
                    </div>
                    <div :class="css.steps">
                        <h3 :class="css.name">{{ $t("RNASplicerOperatingSteps6") }}</h3>
                        <div>{{ $t("RNASplicerOperatingSteps6Msg") }}</div>
                    </div>
                </div>
            </section>
            <section :class="css.try" class="container">
                <h2 :class="css.name">{{ $t("RNASplicerNow") }}</h2>
                <div :class="css.inputs">
                    <mutations-inputs mode="RNA Splicer" v-on="ons.inputs" />
                </div>
            </section>

            <section :class="css.lightspot" class="container">
                <h2 :class="css.name">{{ $t("RNASplicerExampleName") }}</h2>
                <div :class="css.content">
                    <div :class="css.cards">
                        <div :class="css.item">
                            <h3 :class="css.title">{{ $t("RNASplicerExample1Title") }}</h3>
                            <div :class="css.text">{{ $t("RNASplicerExample1Text") }}</div>
                        </div>
                        <div :class="css.item">
                            <h3 :class="css.title">{{ $t("RNASplicerExample2Title") }}</h3>
                            <div :class="css.text">{{ $t("RNASplicerExample2Text") }}</div>
                        </div>
                        <div :class="css.item">
                            <h3 :class="css.title">{{ $t("RNASplicerExample3Title") }}</h3>
                            <div :class="css.text">{{ $t("RNASplicerExample3Text") }}</div>
                        </div>
                        <div :class="css.item">
                            <h3 :class="css.title">{{ $t("RNASplicerExample4Title") }}</h3>
                            <div :class="css.text">{{ $t("RNASplicerExample4Text") }}</div>
                        </div>
                    </div>
                    <div :class="css.image">
                        <img class="max-w-full my-[48px]" v-src="2" />
                    </div>
                    <div :class="css.image">
                        <img class="max-w-full" v-src="3" />
                    </div>
                </div>
            </section>
            <section :class="css.try" class="container">
                <h2 :class="css.name">{{ $t("RNASplicerStartYourPredictionNow") }}</h2>
                <div :class="css.inputs">
                    <mutations-inputs mode="RNA Splicer" v-on="ons.inputs" />
                </div>
            </section>

            <section :class="css.faqs" class="container">
                <h2 :class="css.name">{{ $t("RNASplicerFAQs") }}</h2>
                <div :class="css.content">
                    <div :class="css.faq">
                        <h3 :class="css.issue">
                            <div :class="css.tap">Q1</div>
                            <div :class="css.context">{{ $t("RNASplicerFAQIssue1") }}</div>
                        </h3>

                        <div :class="css.answer">{{ $t("RNASplicerFAQAnswer1") }}</div>
                    </div>

                    <div :class="css.faq">
                        <h3 :class="css.issue">
                            <div :class="css.tap">Q2</div>
                            <div :class="css.context">{{ $t("RNASplicerFAQIssue2") }}</div>
                        </h3>

                        <div :class="css.answer">{{ $t("RNASplicerFAQAnswer2") }}</div>
                    </div>

                    <div :class="css.faq">
                        <h3 :class="css.issue">
                            <div :class="css.tap">Q3</div>
                            <div :class="css.context">{{ $t("RNASplicerFAQIssue3") }}</div>
                        </h3>

                        <div :class="css.answer">{{ $t("RNASplicerFAQAnswer3") }}</div>
                    </div>

                    <div :class="css.faq">
                        <h3 :class="css.issue">
                            <div :class="css.tap">Q4</div>
                            <div :class="css.context">{{ $t("RNASplicerFAQIssue4") }}</div>
                        </h3>

                        <div :class="css.answer">{{ $t("RNASplicerFAQAnswer4") }}</div>
                    </div>

                    <div :class="css.faq">
                        <h3 :class="css.issue">
                            <div :class="css.tap">Q5</div>
                            <div :class="css.context">{{ $t("RNASplicerFAQIssue5") }}</div>
                        </h3>

                        <div :class="css.answer">{{ $t("RNASplicerFAQAnswer5") }}</div>
                    </div>
                    <div :class="css.faq">
                        <h3 :class="css.issue">
                            <div :class="css.tap">Q6</div>
                            <div :class="css.context">{{ $t("RNASplicerFAQIssue6") }}</div>
                        </h3>

                        <div :class="css.answer">{{ $t("RNASplicerFAQAnswer6") }}</div>
                    </div>
                </div>
            </section>

            <section :class="css.recommendeds" class="container">
                <h2 :class="css.name">{{ $t("VPPRecommendedTools") }}</h2>
                <div :class="css.content">
                    <ProjectRoute :class="css.tool" v-for="(value, key) in options.recommendeds" :to="value.route" :key="key">
                        <img :class="css.cover" :src="value.img" :alt="value.name" />
                        <div :class="css.info">
                            <h3 :class="css.name">{{ value.name }}</h3>
                            <div :class="css.description">{{ value.descript }}</div>
                        </div>
                    </ProjectRoute>
                </div>
            </section>
        </div>
    </NuxtLayout>
</template>

<script lang="ts" setup>
//* Vue
import type { Directive } from "vue";
//* 组件库
import { $loading, UiModal } from "various-ui";
//* 公共组件
import { ConfirmModal } from "@/components/windows";
//* 全局函数
import { Formats } from "@/assets/js";
//* 私有组件
import MutationsInputs from "@/views/tool/components/mutations-inputs/index.vue";
import type { ModuleFormData } from "@/views/tool/components/mutations-inputs/src/types";
//* 组件属性
import { useOptions } from "./src/options";
//* 样式
import css from "./index.module.less";

//* 图片资源导入
const images = import.meta.glob("./src/images/*/*.webp", { query: "url", import: "default" });

//* 插件
const i18n = useI18n();
const route = useRoute();
//* 配置
const options = useOptions();
//* 节点
const nodes = {
    info: useTemplateRef<InstanceType<typeof UiModal>>("info"),
    confirm: useTemplateRef<InstanceType<typeof ConfirmModal>>("confirm"),
    inputs: useTemplateRef<InstanceType<typeof MutationsInputs>>("inputs"),
};

//* 函数列表
const methods = {
    //* 确认函数
    confirm: (response: { datas: ModuleFormData[]; syns: boolean }) => {
        console.log("表单提交数据：", response);
        //* 数据处理
        $loading.open({ message: i18n.t("UnderLoad"), delay: 200 });
        const data = response.datas.map((v) => {
            return {
                ref: v.ref,
                alt: v.alt,
                name: v.name,
                gene_id: v.id,
                gene_pos: v.data.range?.start || -1,
                transcript_id: v.transcript,
            };
        });

        //* 接口请求
        api.frontend("/api/ai/splicer", {
            data: { data: data },
            method: "POST",
            finally: () => $loading.close(),
            success: (response) => {
                window.open(routerResolve({ name: "RnaSplicerResult", params: { id: response } }).href, "_blank");
            },
        });
    },

    // //* 跳转函数
    next: () => {
        if (i18n.locale.value == "zh") open("https://www.bilibili.com/video/BV1m7LCz9EL6", "_blank");
        else {
            open("https://www.youtube.com/watch?v=j74Nr-HlAFE", "_blank");
        }
    },
};

const ons = {
    inputs: {
        info: () => nodes.info.value?.openModal(),
        video: methods.next,
        image: () => open(routerResolve({ name: "RnaSplicerTutorials" }).href, "_blank"),
        submit: (response: { datas: ModuleFormData[]; syns: boolean }) => {
            if (response.datas.find((v) => !v.alt)) nodes.confirm.value?.open(response);
            else {
                methods.confirm(response);
            }
        },
    },
};

//* 指令
const vSrc: Directive<HTMLImageElement, string | number> = {
    created: (_node, response, vnode) => {
        images[`./src/images/${i18n.locale.value}/${response.value.toString()}.webp`]?.().then((src) => {
            vnode.el.src = src;
        });
    },
};

//* 组件挂载时通过URL参数获取数据
onMounted(() => {
    const uid = Formats.query(route.query.uuid);
    if (!uid) return;
    else {
        $loading.open({ message: "" });
        api.frontend("/api/bio/variant/params", {
            data: { id: uid },
            error: () => $loading.close(),
            hidden: true,
            success: (response) => {
                //* 表单初始化
                nextTick(() => {
                    nodes.inputs.value?.init(response);
                });
            },
        });
    }
});
</script>
